import "@app/scss/variables.scss";

import React, { useEffect, useState } from "react";

import axiosSession from "@app/config/axiosSession";
import genericAdvancedQuery from "@app/helpers/genericAdvancedQuery";
import useGenericToastify from "@app/hooks/useGenericToastify";
import CMSTable from "@components/Table/CMSTable";
import Modal from "../assets/Modal/Modal";
import { useTranslation } from "react-i18next";
import { DeleteOutlined } from "@ant-design/icons";

const Newsletters = () => {
  const { t } = useTranslation();
  const { notifySuccess, notifyError } = useGenericToastify();
  const [itemData, setItemData] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [shouldTableRefresh, setShouldTableRefresh] = useState(false);
  const [CMSTableView, setCMSTableView] = useState("table");

  const urls = {
    get: "/api/search/frontoffice/historical-queries/"
  };

  const columns = [
    {
      title: t("cms.plugins.newsletters.structure.title"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: "40%",
      render: (text, record) => (
        <div
          style={{ display: "flex", flexDirection: "column" }}
          title={!record.advanced ? record.query : genericAdvancedQuery(record)}
        >
          {!record.advanced ? (
            <p>{record.query}</p>
          ) : (
            genericAdvancedQuery(record)
          )}
        </div>
      )
    },
    {
      title: t("cms.plugins.newsletters.structure.created"),
      dataIndex: "date",
      key: "date",
      sorter: true,
      width: "15%"
    },
    {
      title: t("cms.plugins.newsletters.structure.type"),
      dataIndex: "advanced",
      key: "advanced",
      sorter: true,
      width: "10%",
      render: (text, record) =>
        record.advanced
          ? t("cms.plugins.newsletters.typeAdvanced")
          : t("cms.plugins.newsletters.typeSimple")
    },
    {
      title: t("cms.plugins.bookmarks.structure.actions"),
      dataIndex: "",
      sorter: false,
      width: "8%",
      fixed: "right",
      render: (text, record) => (
        <button
          className="btn btn--text-black"
          title={t("cms.plugins.newsletters.actions.delete")}
          aria-label={t("cms.plugins.newsletters.actions.delete")}
          onClick={() => onDelete(record)}
        >
          <DeleteOutlined className="anticon-dark" aria-hidden="true" />{" "}
          {CMSTableView === "list" &&
            t("cms.plugins.newsletters.actions.delete")}
        </button>
      )
    }
  ];

  useEffect(() => {
    if (shouldTableRefresh) {
      setShouldTableRefresh(false);
    }
  }, [shouldTableRefresh]);

  const onDelete = item => {
    setItemData({ id: item.id, name: item.name });
    setModalIsOpen(true);
  };

  const onConfirmDelete = id => {
    axiosSession
      .delete(`/api/search/frontoffice/subscribe/${id}/`)
      .then(() => {
        notifySuccess(t("cms.plugins.newsletters.message.deleteSuccess"));
        // waiting for indexation
        setTimeout(() => setShouldTableRefresh(true), 1000);
      })
      .catch(err => {
        notifyError(t("cms.plugins.newsletters.message.deleteError"));
        console.error(err);
      })
      .finally(() => {
        setModalIsOpen(false);
      });
  };

  return (
    <>
      <Modal
        open={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        title={t("cms.plugins.bookmarks.message.headerTitle")}
        content={
          <div className="only-text" key={itemData.id}>
            <DeleteOutlined />
            <span>{t("cms.plugins.bookmarks.message.bodyContent")}</span>
          </div>
        }
        buttons={
          <>
            <button
              className="btn btn--text"
              onClick={() => setModalIsOpen(false)}
              onKeyPress={() => setModalIsOpen(false)}
            >
              {t("cms.plugins.bookmarks.message.btnDeleteNo")}
            </button>
            <button
              className="btn"
              onClick={() => onConfirmDelete(itemData.id)}
            >
              {t("cms.plugins.bookmarks.message.btnDeleteYes")}
            </button>
          </>
        }
      />
      <CMSTable
        columns={columns}
        dataUrl={urls.get}
        listView
        shouldTableRefresh={shouldTableRefresh}
        extraParams={{ newsletter: 1 }}
        setUpperView={setCMSTableView}
      />
    </>
  );
};

export default Newsletters;
